var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44661 14.6259C1.93642 13.6268 0.610096 5.33478 7.54805 4.13592C14.486 2.93706 15.2002 9.96369 14.6901 13.6269C14.52 14.4594 13.6698 15.6249 12.6495 16.1244L6.5278 19.6211C5.50751 20.1206 3.46693 20.5202 3.46693 18.1225C3.46693 16.2646 3.16062 15.7864 2.78537 15.2004C2.67633 15.0302 2.56147 14.8508 2.44661 14.6259Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9886 5.13867C15.2703 5.15018 14.8916 6.00321 15.2082 6.64801C16.0294 8.32033 16.4573 10.3259 16.3601 12.2401C16.3191 13.0481 17.0873 13.6747 17.7636 13.2308C20.266 11.588 23.4252 8.37811 21.2999 6.36234C20.2436 5.36053 18.0049 5.10636 15.9886 5.13867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiver);
export default __webpack_public_path__ + "static/media/liver.76b311b5b5a32b33bfe8394e3da49dfd.svg";
export { ForwardRef as ReactComponent };